<script setup lang="ts">
import { computed, toRef } from 'vue'
import { contactTypeClassMap } from '@/modules/expert/contacts/utils/contactTypeClassMap'
import type { CorporativeContactType } from '@/modules/expert/corporative-contacts/types'

type ChipKey = CorporativeContactType

const props = defineProps<{
  modelValue?: ChipKey[]
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: ChipKey[]): void
}>()

const modelValue = toRef(props, 'modelValue')
const selected = computed<ChipKey[]>(() => modelValue.value ?? [])

const toggleValue = (k: ChipKey) => {
  const updated = selected.value.includes(k)
    ? selected.value.filter((v) => v !== k)
    : [...selected.value, k]

  emit('update:modelValue', updated)
}

const chipColor = (k: ChipKey) => {
  return selected.value.includes(k)
    ? contactTypeClassMap[k as keyof typeof contactTypeClassMap]
    : 'grey'
}

// garante que só teremos as chaves válidas
const keys = computed(() => Object.keys(contactTypeClassMap) as ChipKey[])
</script>

<template>
  <div class="chip-wrap d-flex align-center w-100 flex-wrap" style="gap: 8px">
    <v-chip
      v-for="k in keys"
      :key="k"
      :color="chipColor(k)"
      :class="[
        selected.includes(k)
          ? contactTypeClassMap[k as keyof typeof contactTypeClassMap]
          : '',
        'chip-label justify-center',
      ]"
      style="height: 28px; width: 128px; cursor: pointer; color: white"
      @click="toggleValue(k)"
    >
      {{ $t(`contacts.corporative.${k}`) }}
    </v-chip>
  </div>
</template>

<style scoped>
.chip-label {
  font-family: 'Open Sans', sans-serif;
  font-weight: 400;
  font-size: 14px;
}

.chip-label :deep(.v-chip__content) {
  font-family: inherit !important;
  font-weight: inherit !important;
  font-size: inherit !important;
  line-height: inherit !important;
}

@media (max-width: 959.98px) {
  .chip-label {
    font-size: 10px;
    font-weight: 400;
  }
}
</style>
